import { useMemo } from 'react'
import Link from 'next/link'
import validation from '@components/form/validation/field/wideo'
import Icon from '@components/shared/Icon'
import useT from '@hooks/useTranslation'
import extractYoutubeId from '@utils/video/extractYoutubeId'

import styles from 'styles/add/Video.module.css'

const { pattern: { value: videoRegexp }} = validation

const Video = ({ offer: { video_link } = {}}) => {
    if (!video_link) return null
    const videoLink = ensureProtocol(video_link)

    const isValid = videoRegexp.test(videoLink)
    return isValid
        ? <EmbedVideo video={videoLink} />
        : <LinkVideo link={videoLink} />
}

function EmbedVideo ({ video }) {
    const getEmbedable = () => `https://www.youtube.com/embed/${extractYoutubeId(video)}`
    const embedable = useMemo(() => getEmbedable(), [video])
    return (
        <div className={styles.video}>
             <iframe
                width="100%"
                height="100%"
                src={embedable}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen></iframe>
        </div>
    )
}

function LinkVideo ({ link }) {
    return (
        <div className={styles.link}>
            <Link href={link}>
                <a target="_blank" rel="noopener noreferrer">
                    {useT('Zobacz film video')} <Icon>open_in_new</Icon>
                </a>
            </Link>
        </div>
    )
}

function ensureProtocol (link, protocol) {
    return link.startsWith('http')
        ? link
        : `${protocol||'https'}://${link}`
}

export default Video